<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Extraction des utilisateurs ATLAS </strong>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="5">
            <b-form-group>
              <b-form-checkbox
                id="checkbox-active"
                v-model="includeInactif"
                name="includeInactif"
                value=true
                unchecked-value=false
                switch>
                  Inclure les utilisateurs désactivés
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import { checkSIREN } from '@/utils/fileHelper';
  import moment from 'moment';

  export default {
    name: "ExtractionUtilisateurAtlas",
    data() {
      return {
        includeInactif: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      generateExcel() {
        let self = this;
        let data = {
          includeInactif: this.includeInactif,
        };
        // console.log('this.fileName',this.fileName)
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post(`/espaceGestion/extractions/user-atlas`, data, {responseType: "arraybuffer"})
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.downloadExportedFile(response, `Extraction_utilisateur_atlas.csv`);
            // this.downloadExportedFile(response, `${this.fileName}.xlsx`);
          })
          .catch(function(error){
            console.log(error)
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
          });

      },
      downloadExportedFile(response, filename) {
        // console.log('downloadExportedFile',response);
        let newBlob = new Blob([response.data], {type: 'text/csv'});
        // let newBlob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100)

      }
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>


